import { render } from "./index.vue?vue&type=template&id=795ba7cf&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=795ba7cf&lang=scss"
import "./index.vue?vue&type=style&index=1&id=795ba7cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795ba7cf"]])

export default __exports__